if (!customElements.get('product-gallery-thumbnails')) {
  class ProductGalleryThumbnails extends HTMLElement {
    constructor() {
      super();
      this._abortController = null;
      this._unsubscribe = null;
      this._targetId = null;
      this._thumbnails = [];
    }

    connectedCallback() {
      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this._targetId = this.dataset.sliderTarget;
      this._thumbnails = Array.from(this.querySelectorAll('[data-thumbnail-index]'));

      this._thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => this._onThumbnailClick(thumb), { signal });
      });

      this._unsubscribe = theme.pubsub?.subscribe(theme.pubsub.events.SLIDER_CHANGE, (data) => {
        if (!this._targetId || data.id !== this._targetId) return;
        this._setActive(data.currentIndex);
      });
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._unsubscribe?.();
    }

    _onThumbnailClick(thumb) {
      if (!this._targetId) return;
      const slider = document.getElementById(this._targetId);
      if (!slider || typeof slider.navigateToSlide !== 'function') return;

      const index = parseInt(thumb.dataset.thumbnailIndex, 10);
      if (Number.isNaN(index)) return;

      slider.navigateToSlide(index);
    }

    _setActive(index) {
      this._thumbnails.forEach((thumb, i) => {
        const isActive = i === index;
        thumb.classList.toggle('product-gallery-thumbnails__item--active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
  }

  customElements.define('product-gallery-thumbnails', ProductGalleryThumbnails);
}
